import axios from 'axios';

let lastCallTime = 0;
const DEFAULT_THROTTLE_INTERVAL = 500; // Optimizado: 2 imágenes por segundo para mejor validación

const params = new Proxy(new URLSearchParams(window.location.search), {
  get: (searchParams, prop) => searchParams.get(prop),
});

const codeTransaction = params.codeTransaction;

export async function documentValidator({
  base64Data,
  urlService,
  isFront,
  documentType,
  processId,
  config = {},
  batchImages = null,
}) {
  try {
    const validatorConfig = config.documentValidator || {};

    const throttleInterval = parseInt(
      validatorConfig.throttle_interval || DEFAULT_THROTTLE_INTERVAL,
      10
    );

    const now = Date.now();
    const diff = now - lastCallTime;
    if (diff < throttleInterval) {
      await new Promise((r) => setTimeout(r, throttleInterval - diff));
    }
    lastCallTime = Date.now();

    const quality_threshold = validatorConfig.quality_threshold;
    const blur_threshold = validatorConfig.blur_threshold;
    const glare_threshold = validatorConfig.glare_threshold;
    const return_original = validatorConfig.return_original;
    const return_cropped = validatorConfig.return_cropped;
    const enable_batch = validatorConfig.enable_batch;
    const use_regula = validatorConfig.use_regula;

    const formData = new FormData();

    if (enable_batch === 'true' && batchImages && batchImages.length > 0) {
      batchImages.forEach((img, index) => {
        formData.append('documentFile', img, `file_${index}`);
      });
    } else {
      formData.append('documentFile', base64Data, 'file');
    }

    formData.append('isFront', String(isFront));
    formData.append('processId', processId || '');
    formData.append('idTransaction', codeTransaction || '');
    formData.append('documentType', documentType || '1');

    if (return_original !== undefined) formData.append('return_original', return_original);
    if (return_cropped !== undefined) formData.append('return_cropped', return_cropped);
    if (enable_batch !== undefined) formData.append('enable_batch', enable_batch);
    if (quality_threshold !== undefined) formData.append('quality_threshold', quality_threshold);
    if (blur_threshold !== undefined) formData.append('blur_threshold', blur_threshold);
    if (glare_threshold !== undefined) formData.append('glare_threshold', glare_threshold);
    if (use_regula !== undefined) formData.append('use_regula', use_regula);

    const response = await axios.post(
      `${urlService}/api/DocumentValidatorV2/ValidateDocument`,
      formData,
      {
        headers: { Accept: '*/*' },
        timeout: 15000,
      }
    );
    return response;
  } catch (error) {
    return {
      data: { quality: false, status: 'error' },
      status: error.response?.status || 500,
    };
  }
}

export async function validateSignature({
  preparedFile,
  signature,
  hash,
  expiresAt,
  processId,
}) {
  try {
    const formData = new FormData();
    formData.append('image', preparedFile);
    formData.append('signature', signature);
    formData.append('hash', hash);
    formData.append('expiresAt', expiresAt);
    formData.append('processId', processId);

    const response = await axios.post(
      'https://api-dev.ado-tech.com/api/key/validate-signature',
      formData,
      { headers: { Accept: '*/*' } }
    );
    return response;
  } catch {
    return { data: { quality: false } };
  }
}

export async function validateImage(
  picture,
  number,
  codeTx,
  deviceType,
  urlServiceLiveness,
  spf
) {
  try {
    const formData = new FormData();
    formData.append('processId', codeTx);
    formData.append('imageCount', number);
    formData.append('deviceType', deviceType);
    formData.append('SPF', spf);
    picture.forEach((blob, idx) => {
      if (blob instanceof Blob) formData.append('data', blob, `image_${idx + 1}.jpeg`);
    });

    const resp = await fetch(
      `${urlServiceLiveness}/api/images/ValidateImageFromFiles`,
      {
        method: 'POST',
        headers: {
          apiKey: 'CexMnVCV4I8Xz32Az467cVi1kauX8DFx',
          Meta: JSON.stringify({
            OS: String(deviceType || '').toUpperCase(),
            CALIBRATION: 'SOFT',
          }),
        },
        body: formData,
      }
    );
    if (!resp.ok) throw new Error('Request failed');
    const result = await resp.json();
    return result;
  } catch (e) {
    throw e;
  }
}

export async function validateImageNormal(
  picture,
  number,
  codeTx,
  deviceType,
  urlServiceLiveness
) {
  try {
    const formData = new FormData();
    formData.append('processId', codeTx);
    formData.append('imageCount', number);
    formData.append('deviceType', deviceType);
    formData.append('data', picture, 'image.jpeg');

    const resp = await fetch(
      `${urlServiceLiveness}/api/images/ValidateImageFromFile`,
      {
        method: 'POST',
        headers: {
          apiKey: 'CexMnVCV4I8Xz32Az467cVi1kauX8DFx',
          Meta: JSON.stringify({
            OS: String(deviceType || '').toUpperCase(),
            CALIBRATION: 'SOFT',
          }),
        },
        body: formData,
      }
    );
    if (!resp.ok) throw new Error('Request failed');
    const result = await resp.json();
    return result;
  } catch (e) {
    throw e;
  }
}
